// Firebase configuration and initialization

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// Firebase configuration
// Project: personafeedback-b5c5c
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics (only in browser environment)
let analytics: Analytics | null = null;
if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
  analytics = getAnalytics(app);
}
export { analytics };

// Initialize App Check for bot protection
// Uses ReCAPTCHA v3 in production, debug token in development
if (typeof window !== 'undefined') {
  const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (appCheckSiteKey) {
    // Production: Use ReCAPTCHA v3
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
    console.log('Firebase App Check initialized with ReCAPTCHA v3');
  } else if (process.env.NODE_ENV === 'development') {
    // Development: Use debug token
    // Set this in Firebase Console > App Check > Apps > Web App > Debug tokens
    // Then set REACT_APP_APPCHECK_DEBUG_TOKEN in .env.local
    const debugToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
    if (debugToken) {
      (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider('6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'), // Test key
        isTokenAutoRefreshEnabled: true,
      });
      console.log('Firebase App Check initialized with debug token');
    }
  }
}

export default app;
